module.exports = __webpack_public_path__ + "img/8b39c6a82822271ffed50a5fdc7ddc1d.svg";